__turbopack_context__.v({
  "root": "ClubFansLeaderboard-module-scss-module__7hcmmG__root",
});
